var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.46002 12.7101L14.12 18.3601C14.3078 18.5494 14.5634 18.6559 14.83 18.6559C15.0967 18.6559 15.3523 18.5494 15.54 18.3601C15.9277 17.97 15.9277 17.3401 15.54 16.9501L10.59 11.9501L15.54 7.00005C15.9277 6.61002 15.9277 5.98009 15.54 5.59005C15.3529 5.3992 15.0973 5.29116 14.83 5.29005C14.5628 5.29116 14.3071 5.3992 14.12 5.59005L8.46002 11.2401C8.25481 11.4294 8.13809 11.6959 8.13808 11.9751C8.13808 12.2543 8.25481 12.5207 8.46002 12.7101Z",
    fill: "#6F6F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronBack);
export default __webpack_public_path__ + "static/media/chevron-back.2d95f0f5.svg";
export { ForwardRef as ReactComponent };